import { RedirectStatus } from "@/components/redirectFlow/ClientRedirect.types";
import { OS } from "@/lib/utils/getDeviceOs";

export type RedirectScreen =
  | { kind: "appPreview"; html: string }
  | { kind: "customHtml"; html: string }
  | { kind: "spinner" }
  | { kind: "appOpenAttempted"; os: OS }
  | { kind: "copyLink" }
  | { kind: "status"; os: OS };

export type RedirectScreenState = {
  os: OS | null;
  shouldSendFingerprintImmediately: boolean | null;
  hasNowhereToGo: boolean;
  appPreviewDocument: string | null;
  showAppPreview: boolean;
  customHtml: string | null | undefined;
  triesAppOpen: boolean;
  attemptsAppOpen: boolean;
  redirectStatus: RedirectStatus | null;
};

/** Which screen ClientRedirect renders. The order of the checks is the rule. */
export function selectRedirectScreen({
  os,
  shouldSendFingerprintImmediately,
  hasNowhereToGo,
  appPreviewDocument,
  showAppPreview,
  customHtml,
  triesAppOpen,
  attemptsAppOpen,
  redirectStatus,
}: RedirectScreenState): RedirectScreen {
  // OS detection runs in an effect, so the first render always lands here.
  if (!os || shouldSendFingerprintImmediately === null || hasNowhereToGo) {
    if (appPreviewDocument) {
      return { kind: "appPreview", html: appPreviewDocument };
    }
    // The app-open screen replaces it as soon as the OS is known, so it would
    // only flash.
    if (customHtml && !triesAppOpen) {
      return { kind: "customHtml", html: customHtml };
    }
    return { kind: "spinner" };
  }

  // Checked before copy-link, App Preview and custom HTML, because their
  // buttons cannot record the click before the store opens. See
  // lib/webViewAppOpen.
  if (attemptsAppOpen) return { kind: "appOpenAttempted", os };

  if (!shouldSendFingerprintImmediately) return { kind: "copyLink" };

  if (!redirectStatus) {
    if (showAppPreview && appPreviewDocument) {
      return { kind: "appPreview", html: appPreviewDocument };
    }
    if (customHtml) return { kind: "customHtml", html: customHtml };
  }

  return { kind: "status", os };
}
